import React from 'react';
import isEqual from 'lodash/isEqual';
import { Map } from '../map/components/map';
import { Marker } from '../map/components/marker';
import MapPin from './map-pin';
import { getMinBounds, isMobileScreen, maxBoundsCorners } from '../map-utils';

const defaultCenter = {lat: 54.559322, lng: -4.174804};

export class StoreLocatorMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      center: defaultCenter,
      zoom: props.defaultZoom,
      bounds: null
    };
    this.handleMoveEnd = this.handleMoveEnd.bind(this);
    this.handleBoundsChanged = this.handleBoundsChanged.bind(this);
    this.handleMapUpdated = this.handleMapUpdated.bind(this);
    this.handleMarkerSelected = this.handleMarkerSelected.bind(this);
    this.handleZoomChanged = this.handleZoomChanged.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.origin, prevProps.origin)) {
      let mapCenter = this.props.origin || defaultCenter;
      this.setState({
        center: mapCenter,
        zoom: this.props.origin ? this.state.zoom : this.props.defaultZoom
      });
    } else if (!isEqual(this.props.stores, prevProps.stores) && this.props.adjustVisibleStores) {
      this.setMinBound(this.props.minVisibleStores);
    }
  }

  handleMoveEnd({center, bounds}) {
    this.props.onMoveEnd(center, bounds);
  }

  handleBoundsChanged({bounds}) {
    this.props.onBoundsChanged(bounds);
  }

  handleMapUpdated({bounds}) {
    this.props.onBoundsChanged(bounds);
  }

  handleZoomChanged(zoom) {
    this.setState({
      zoom: zoom
    });
  }

  setMinBound(minVisibleStores) {
    if (this.props.stores && this.props.stores.length > 0) {
      let bounds =
        getMinBounds(this.props.origin, this.props.stores, minVisibleStores, this.props.maxRadius);

      this.setState({bounds});
    }
  }

  handleMarkerSelected(storeId) {
    window.ga && window.ga('send', 'event', 'new store locator', 'marker click', storeId);
    this.props.onMarkerSelected(storeId);
  }

  htmlPin(store, index) {
    const mapPin = new MapPin(store, this.props.isInPostStoreLocatorRebrandEnabled);
    const pinNumber = this.props.isInPostStoreLocatorRebrandEnabled && store.store_type === "PaypointStore" ? "" :
      `<span class="${mapPin.numberClass()}">${index + 1}</span>`;
    return `
      <div class="phase-2-numeric-map-pin">
        <img src="${mapPin.icon()}" alt="pin-icon" class="pin" />
        ${pinNumber}
      </div>
    `;
  }

  mapIcon() {
    return { url: '/assets/store-locator/map-pin-red.svg', scaledSize: {width: 30, height: 40}};
  }

  scaledSize() {
    return {width: 35, height: 35};
  }

  render() {
    return (
      <div className={this.props.collapseMap ? " -height-zero" : ""}>
        <Map
          height={isMobileScreen ? "75vh" : "85vh"}
          className={"phase2 google-maps-container"}
          center={this.state.center}
          zoom={this.state.zoom}
          bounds={this.state.bounds}
          minZoom={6}
          maxBoundsCorners={maxBoundsCorners}
          mapTypeControl={false}
          streetViewControl={true}
          useOsm={this.props.useOsm}
          osmUrl={this.props.osmUrl}
          onMapCreated={this.props.onMapCreated}
          onMoveEnd={this.handleMoveEnd}
          onBoundsChanged={this.handleBoundsChanged}
          onMapUpdated={this.handleMapUpdated}
          onZoomChanged={this.handleZoomChanged}
          isPhase2Map={true}
        >
          {this.props.origin &&
            <Marker
              key={this.props.origin.lat + this.props.origin.lng}
              lat={this.props.origin.lat}
              lng={this.props.origin.lng}
              draggable={false}
              useOsm={this.props.useOsm}
              icon={this.mapIcon()}
            />
          }
          {this.props.stores.map((store, index) => {
            let closingMessage =
              `<div className='store-closed-message'>
                <div className='closed-store-name'> ${store.name} </div>
                <div className='closed-store-message-text'>${store.closing_message} </div>
              </div>`
            let content = store.closed ? closingMessage : null;
            return (
              <Marker
                key={store.id}
                lat={store.lat}
                lng={store.lng}
                onClick={() => this.handleMarkerSelected(store.id)}
                draggable={false}
                infoWindowContent={content}
                selected={store.selected}
                useOsm={this.props.useOsm}
                icon={{html: this.htmlPin(store, index), scaledSize: this.scaledSize()}}
              />
            )
          }
          )}
        </Map>
      </div>
    );
  }
}
